import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function PartnersSection() {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Partners & Certificeringen</h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            SOL-VI werkt samen met toonaangevende partners en beschikt over alle benodigde certificeringen voor veilig en professioneel werk.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* OpenSolar Partnership - Simplified */}
          <Card className="shadow-card">
            <div className="p-6">
              <div className="flex items-center gap-4 mb-4">
                <img 
                  src="/lovable-uploads/f7c9e6b8-9258-4896-9adb-097f5c902979.png" 
                  alt="OpenSolar Logo" 
                  className="h-12 w-auto"
                  loading="lazy" 
                  decoding="async"
                  width="48"
                  height="48"
                  style={{ maxWidth: '48px', height: 'auto' }}
                />
                <div>
                  <h3 className="text-2xl font-bold">OpenSolar Partnership</h3>
                  <p className="text-muted-foreground">Geavanceerde ontwerptechnologie</p>
                </div>
              </div>
              <p className="text-muted-foreground mb-4">
                SOL-VI is gecertificeerd partner van OpenSolar, het wereldwijd toonaangevende platform voor zonne-energie ontwerp en verkoop. 
                Deze samenwerking stelt ons in staat om:
              </p>
              <div className="space-y-2 text-muted-foreground">
                <div className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  Precise 3D-modelling van uw dak voor optimale paneel plaatsing
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  Gedetailleerde schaduwanalyse en energieopbrengst berekeningen
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  Professionele presentaties met realistische visualisaties
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  Accurate kostenberekeningen en terugverdientijd analyses
                </div>
              </div>
            </div>
          </Card>

          {/* Certificeringen - Simplified */}
          <Card className="shadow-card">
            <div className="p-6">
              <h3 className="text-2xl font-bold mb-2">Certificeringen & Kwaliteit</h3>
              <p className="text-muted-foreground mb-6">Veiligheid en kwaliteit gegarandeerd</p>
              
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <img 
                    src="/lovable-uploads/46dd609b-476b-4a82-a235-05cb878ddc9c.png" 
                    alt="VCA Certificering" 
                    className="h-8 w-auto"
                    loading="lazy" 
                    decoding="async"
                    width="32"
                    height="32"
                    style={{ maxWidth: '32px', height: 'auto' }}
                  />
                  <div>
                    <h4 className="font-semibold">VCA Gecertificeerd</h4>
                    <p className="text-sm text-muted-foreground">Veiligheid, Gezondheid en Milieu certificering</p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <img 
                    src="/lovable-uploads/3a3300e9-fdc9-4df9-8b39-6d0e6d17358f.png" 
                    alt="VGM Checklist Aannemers" 
                    className="h-12 w-auto"
                    loading="lazy" 
                    decoding="async"
                    width="48"
                    height="48"
                    style={{ maxWidth: '48px', height: 'auto' }}
                  />
                  <div>
                    <h4 className="font-semibold">VGM Checklist Aannemers</h4>
                    <p className="text-sm text-muted-foreground">Erkend voor veilig werken op hoogte</p>
                  </div>
                </div>

                <div className="bg-muted/50 p-4 rounded-lg">
                  <h4 className="font-semibold mb-2">Onze Kwaliteitsgaranties:</h4>
                  <div className="space-y-1 text-sm text-muted-foreground">
                    <div>• 5 jaar volledige garantie op installatie</div>
                    <div>• Gecertificeerde installateurs</div>
                    <div>• Conform alle Nederlandse veiligheidsnormen</div>
                    <div>• 24/7 support en monitoring</div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>

        {/* Logo Showcase - Simplified */}
        <div className="mt-16 text-center">
          <h3 className="text-xl font-semibold mb-8">Vertrouwd door professionals</h3>
          <div className="flex flex-wrap justify-center items-center gap-8 opacity-60">
            <img 
              src="/lovable-uploads/f7c9e6b8-9258-4896-9adb-097f5c902979.png" 
              alt="OpenSolar Partner" 
              className="h-12 w-auto grayscale hover:grayscale-0 transition-all duration-300"
              loading="lazy" 
              decoding="async"
              width="48"
              height="48"
              style={{ maxWidth: '48px', height: 'auto' }}
            />
            <img 
              src="/lovable-uploads/46dd609b-476b-4a82-a235-05cb878ddc9c.png" 
              alt="VCA Gecertificeerd" 
              className="h-10 w-auto grayscale hover:grayscale-0 transition-all duration-300"
              loading="lazy" 
              decoding="async"
              width="40"
              height="40"
              style={{ maxWidth: '40px', height: 'auto' }}
            />
            <img 
              src="/lovable-uploads/3a3300e9-fdc9-4df9-8b39-6d0e6d17358f.png" 
              alt="VGM Erkend" 
              className="h-12 w-auto grayscale hover:grayscale-0 transition-all duration-300"
              loading="lazy" 
              decoding="async"
              width="48"
              height="48"
              style={{ maxWidth: '48px', height: 'auto' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}